// Material swatch functionality moved to global material-swatch-handler.js

// Add to cart functionality check
$(document).ready(function() {
  // Check if product-form custom element is defined
  if (!customElements.get('product-form')) {
    // Fallback: Add direct form submission handling
    $('form[data-type="add-to-cart-form"]').on('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const variantId = formData.get('id');
      
      if (!variantId) {
        return;
      }
      
      // Simple fetch to add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          alert('Error adding to cart: ' + data.description);
        } else {
          // Trigger cart update event
          $(document).trigger('cart:updated');
          // Show success message or update cart drawer
          alert('Product added to cart successfully!');
        }
      })
      .catch(error => {
        alert('Error adding to cart. Please try again.');
      });
    });
  }
});

// Material swatch image change functionality moved to global material-swatch-handler.js

// PRODUCT IMAGE SLIDER FUNCTIONALITY
// Store slider states globally to maintain state across re-renders
const sliderStates = new Map();

// Initialize slider for a specific element
function initializeSlider(slider) {
  const $slider = $(slider);
  const $images = $slider.find(".ab-img");
  const $card = $slider.closest(".main-prd-card");
  const $prevBtn = $card.find(".slider-prev");
  const $nextBtn = $card.find(".slider-next");
  const $currentIndexSpan = $card.find(".current-index");
  
  // Only proceed if there are images
  if ($images.length === 0) {
    return;
  }
  
  // Get or create slider state
  const sliderId = $slider.attr('data-slider-id') || Math.random().toString(36).substr(2, 9);
  $slider.attr('data-slider-id', sliderId);
  
  if (!sliderStates.has(sliderId)) {
    sliderStates.set(sliderId, {
      currentIndex: 0,
      $images: $images,
      $slider: $slider,
      $card: $card,
      $prevBtn: $prevBtn,
      $nextBtn: $nextBtn,
      $currentIndexSpan: $currentIndexSpan
    });
  }
  
  const state = sliderStates.get(sliderId);
  
  // Update counter display with slide up animation
  function updateCounter() {
    if (state.$currentIndexSpan.length) {
      // Add slide up animation
      state.$currentIndexSpan.addClass('slide-up-in');
      state.$currentIndexSpan.text(state.currentIndex + 1);
      
      // Remove animation class after completion
      setTimeout(() => {
        state.$currentIndexSpan.removeClass('slide-up-in');
      }, 300);
    }
  }
  
  // Update button states
  function updateButtons() {
    // Remove disabled state since we're allowing looping
    state.$prevBtn.prop('disabled', false);
    state.$nextBtn.prop('disabled', false);
  }
  
  // Show specific image with slide animation
  function showImage(index, direction = 'next') {
    // Update current index
    state.currentIndex = index;
    
    // Update CSS variable for transform
    state.$slider[0].style.setProperty('--current-image-index', state.currentIndex);
    
    // Update counter and buttons
    updateCounter();
    updateButtons();
  }
  
  // Next image
  function nextImage() {
    const nextIndex = state.currentIndex < state.$images.length - 1 ? state.currentIndex + 1 : 0;
    showImage(nextIndex, 'next');
  }
  
  // Previous image
  function prevImage() {
    const prevIndex = state.currentIndex > 0 ? state.currentIndex - 1 : state.$images.length - 1;
    showImage(prevIndex, 'prev');
  }
  
  // Store functions in state for later use
  state.nextImage = nextImage;
  state.prevImage = prevImage;
  state.showImage = showImage;
  state.updateCounter = updateCounter;
  state.updateButtons = updateButtons;
  
  // Initialize
  state.$slider[0].style.setProperty('--current-image-index', state.currentIndex);
  updateCounter();
  updateButtons();
}

// Event delegation for slider buttons - works with dynamically added elements
$(document).on('click', '.slider-navigation .slider-next', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const $button = $(this);
  const $card = $button.closest('.main-prd-card');
  const $slider = $card.find('.product-image-slider');
  
  if ($slider.length) {
    const sliderId = $slider.attr('data-slider-id');
    const state = sliderStates.get(sliderId);
    
    if (state && state.nextImage) {
      state.nextImage();
    } else {
      initializeSlider($slider[0]);
      
      // Get the new slider ID after reinitialization
      const newSliderId = $slider.attr('data-slider-id');
      
      // Try again with the new slider ID
      const newState = sliderStates.get(newSliderId);
      if (newState && newState.nextImage) {
        newState.nextImage();
      }
    }
  }
});

$(document).on('click', '.slider-navigation  .slider-prev', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const $button = $(this);
  const $card = $button.closest('.main-prd-card');
  const $slider = $card.find('.product-image-slider');
  
  if ($slider.length) {
    const sliderId = $slider.attr('data-slider-id');
    const state = sliderStates.get(sliderId);
    
    if (state && state.prevImage) {
      state.prevImage();
    } else {
      initializeSlider($slider[0]);
      
      // Get the new slider ID after reinitialization
      const newSliderId = $slider.attr('data-slider-id');
      
      // Try again with the new slider ID
      const newState = sliderStates.get(newSliderId);
      if (newState && newState.prevImage) {
        newState.prevImage();
      }
    }
  }
});

// Function to reinitialize sliders for newly added content
function reinitializeSliders() {
  const sliders = $(".product-image-slider");
  
  sliders.each(function() {
    const $slider = $(this);
    
    // Only initialize if not already initialized
    if (!$slider.attr('data-slider-id')) {
      initializeSlider(this);
    }
  });
}

// Initialize all existing sliders on page load
$(document).ready(function() {
  reinitializeSliders();
  
  // Material swatch functionality moved to global material-swatch-handler.js
});

// Expose reinitializeSliders and sliderStates globally for external use
window.reinitializeSliders = reinitializeSliders;
window.sliderStates = sliderStates;

// Function to replace slider images
function replaceSliderImages(slider, imagesData) {
  const $slider = $(slider);
  // Get existing slider state
  const sliderId = $slider.attr('data-slider-id');
  const state = sliderStates.get(sliderId);
  
  // Clear existing images
  $slider.empty();
  
  // Add new images
  imagesData.forEach((imageData, index) => {
    const $imageContainer = $('<div>').addClass('bg-product-card-image');
    
    const $img = $('<img>')
      .attr('src', imageData.src)
      .attr('alt', imageData.alt)
      .addClass('ab-img');
    
    if (index === 0) $img.addClass('active');
    
    $imageContainer.append($img);
    $slider.append($imageContainer);
  });
  
  // Update state with new images
  if (state) {
    state.$images = $slider.find('.ab-img');
    state.currentIndex = 0;
    
    // Update total count display
    const $totalCountSpan = state.$card.find('.total-count');
    if ($totalCountSpan.length) {
      $totalCountSpan.text(imagesData.length);
    }
    
    // Update counter and buttons
    if (state.updateCounter) {
      state.updateCounter();
    }
    if (state.updateButtons) {
      state.updateButtons();
    }
    
    // Update CSS variable
    state.$slider[0].style.setProperty('--current-image-index', state.currentIndex);
  } else {
    // If no state exists, initialize the slider
    initializeSlider(slider);
  }
}
